import makeLookupModal from "../../UI/LookupModal/LookupModal";
import HighSchoolTranscriptStatusLookup from "./HighSchoolTranscriptStatusLookup";
const HighSchoolTranscriptStatusLookupModal = makeLookupModal(HighSchoolTranscriptStatusLookup, {
    pluralEntityName: "High School Transcript Statuses",
});
export default HighSchoolTranscriptStatusLookupModal;
